import axios from "../config";
import { getToken } from "../../utils/session-utils";

export const sendResponse = (
  { questionId, mobileNumber, responseText, sessionId },
  onSuccess,
  onError
) =>
  axios
    .post(
      "/v1/responses",
      {
        questionId,
        mobileNumber,
        responseText,
        sessionId
      },
      {
        headers: {
          Authorization: getToken()
        }
      }
    )
    .then(res => onSuccess(res.data))
    .catch(err => onError(err.message));

export const assignRisk = (
  { sessionId, mobileNumber, riskCategory, userId },
  onSuccess,
  onError
) =>
  axios
    .post(
      "/v1/risk",
      {
        sessionId,
        mobileNumber,
        riskCategory,
        userId
      },
      {
        headers: {
          Authorization: getToken()
        }
      }
    )
    .then(res => onSuccess(res.data))
    .catch(err => onError(err.message));
